import moment from 'moment';

window.Parsley.addValidator('currentOrFutureDate', {
  requirementType: 'string',
  validateString(value) {
    const date = moment(value);
    const today = moment().startOf('day');
    return !date.isBefore(today, 'day');
  },
  messages: {
    en: 'The date cannot be in the past. '
  }
});
